import React from "react";
import { Layout } from "antd";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
//Componentes
import { HomePage } from "../pages/Public/Home/HomePage";
import HeaderLogin from "../components/Admin/Header/HeaderLogin";
import { RefreshToken } from "../helpers/refreshToken";
import {FooterGeneral} from "../components/Compartidos/FooterGeneral/FooterGeneral";
import MenuAspirante from "../components/Admin/Menu/MenuAspirante";
import { LoadRoutes } from "../components/General/LoadRoutes";

//Estilos css
import "../assets/css/Home.css";
// import "../css/tema-institucional.css";
import "../assets/css/tema-institucional.css";

const { Content } = Layout;

/**
 * Layout que contiene la maquetación general de la pantalla al momento de que el usuario inició sesión.
 * @param {Props} props - routes: las rutas que se van a mostrar en el container
 * @return {JSX.Element} LayoutAdmin
 */
const LayoutAdmin = (props) => {
    const { routes } = props;

    const { autenticado } = useSelector((state) => state.usuarioLogin);

    window.scrollTo(0, 0); //Al inicio de la pantalla

    //Se valida que el usuario este autenticado en el sistema
    if (!autenticado) {
        return (
        <>
            <Route path="/" component={HomePage} />
            <Redirect to="/" />
        </>
        );
    }

    return (
        <Layout>
            <Layout
                className="site-layout"
                style={{ minHeight: "100vh", background: "#fff" }}
            >
                <RefreshToken />
                {/* Header */}
                <HeaderLogin />
                <MenuAspirante />

                <Content className="layout">
                {/* <Migas /> */}
                {/* Menú */}
                {/* Contenido dónde se renderizarán los componentes */}
                <div >
                    {/* Iteración de las sub-rutas */}
                    <LoadRoutes routes={routes} />
                </div>
                </Content>
                <FooterGeneral />
            </Layout>
        </Layout>
    );
};

export default LayoutAdmin;
